import React from "react";

import { Formik, Form } from "formik";

import { Button, Pane, Typography } from "clearsense-ui/components";
import { Input, Select } from "clearsense-ui/components/formik";

import {
  ASSOCIATE_STEWARD_INITIAL_VALUES,
  ASSOCIATE_STEWARD_VALIDATION_SCHEMA,
} from "../../constants/associateSteward";

const AssociateSteward = ({ isPaneOpen, setIsPaneOpen }) => (
  <Pane isOpen={isPaneOpen} onClose={() => setIsPaneOpen(false)}>
    <Pane.Header>
      <Typography style="h3" type="bold" className="-mt-3">
        Add New Steward for Data Source
      </Typography>
    </Pane.Header>
    <Formik
      initialValues={ASSOCIATE_STEWARD_INITIAL_VALUES}
      validationSchema={ASSOCIATE_STEWARD_VALIDATION_SCHEMA}
    >
      {() => (
        <Form>
          <Pane.Body>
            <div className="py-2 flex w-full flex-col gap-4 overflow-auto">
              <Input
                label="Selected Data Source"
                name="selectedDataSource"
                value="Provider Data Source"
              />
              <Select
                label="Steward Type"
                placeholder="Select Steward Type"
                name="stewardType"
              />
              <Select
                label="Select Steward"
                placeholder="Select Steward"
                name="steward"
              />
            </div>
          </Pane.Body>
          <Pane.Footer className="gap-1">
            <Button label="Save Changes" />
            <Button
              label="Cancel"
              style="secondary"
              onClick={() => setIsPaneOpen(false)}
            />
          </Pane.Footer>
        </Form>
      )}
    </Formik>
  </Pane>
);

export default AssociateSteward;
